export default __webpack_public_path__ + "static/media/small-symplr-logo.81e8e7d9.svg";